import React, { useRef, useEffect, useState } from 'react';

const TopMenuBar = ({ content, selectedIndex, onMenuClick, onClose }) => {
  const menuRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  // 메뉴 아이템 스타일: offset(위쪽 여백) 더 크게 조정
  const menuItemStyle = {
    padding: '12px 28px',
    margin: '0 8px',
    backgroundColor: '#fff',
    color: '#000',
    borderRadius: '20px',
    cursor: 'pointer',
    fontSize: '24px',
    fontFamily: 'AppleSDGothicNeo-Medium',
    whiteSpace: 'nowrap',
    transition: 'all 0.3s ease',
    border: 'none',
    outline: 'none'
  };

  const selectedMenuItemStyle = {
    ...menuItemStyle,
    borderBottom: '3px solid #ff921c'
  };

  // 화살표 버튼 스타일 (검정색 반투명 원형) - 더 연하게 변경 (0.3)
  const arrowButtonStyle = {
    width: '48px',
    height: '48px',
    background: 'rgba(0,0,0,0.3)', // 기존 0.5에서 0.3으로 연하게
    border: 'none',
    borderRadius: '50%',
    fontSize: '2.6rem',
    color: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    
    zIndex: 20,
    boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
    transition: 'background 0.2s, color 0.2s, transform 0.2s',
    opacity: 1,
    pointerEvents: 'auto'
  };

  const leftArrowButtonStyle = {
    ...arrowButtonStyle,
    left: 0,
  };

  const rightArrowButtonStyle = {
    ...arrowButtonStyle,
    right: 0,
    left: 'auto',
  };

  // 메뉴 한 칸씩 스크롤 함수
  const scrollMenu = (direction) => {
    if (!menuRef.current) return;
    const container = menuRef.current;
    // 메뉴 아이템 중 첫 번째를 기준으로 너비 측정
    const firstItem = container.querySelector('.slide-top-menu-item');
    if (!firstItem) return;
    const scrollAmount = firstItem.offsetWidth + 16; // margin 포함
    if (direction === 'left') {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  // 스크롤 위치에 따라 화살표 표시 여부 갱신
  const updateArrowVisibility = () => {
    if (!menuRef.current) {
      setShowLeftArrow(false);
      setShowRightArrow(false);
      return;
    }
    const el = menuRef.current;
    setShowLeftArrow(el.scrollLeft > 5);
    setShowRightArrow(el.scrollWidth - el.clientWidth - el.scrollLeft > 5);
  };

  useEffect(() => {
    updateArrowVisibility();
    const el = menuRef.current;
    if (!el) return;
    el.addEventListener('scroll', updateArrowVisibility, { passive: true });
    window.addEventListener('resize', updateArrowVisibility);
    return () => {
      if (el) el.removeEventListener('scroll', updateArrowVisibility);
      window.removeEventListener('resize', updateArrowVisibility);
    };
  }, [content]);

  return (
    <div style={{
      background: "linear-gradient(to bottom, #e5e5e5, white 10px)",
      display: "flex", 
      justifyContent: "space-between",
      height: "90px", // 높이 10px 증가
      width: "100%",
      boxShadow: "0 8px 6px -6px rgba(0,0,0,0.2)", // 상단과 하단에 그림자 추가
      //boxShadow: "0 -8px 6px -6px rgba(0,0,0,1), 0 8px 6px -6px rgba(0,0,0,0.2)", // 상단과 하단에 그림자 추가
      zIndex: 30,
      position: "sticky", 
      top: 0,
      alignItems: "flex-start" // 위로 정렬
    }}>
      
      <span 
        onClick={onClose}
        style={{
          paddingLeft: "10px", 
          marginTop: "45px", // 기존 40px에서 45px로 offset 증가
          height: "40px", 
          color: "grey", 
          fontSize: "3rem", 
          fontFamily: "AppleSDGothicNeo-Light", 
          display: "flex", 
          alignItems: "end",
          cursor: "pointer"
        }}>
        &times;
      </span>

      {content["topImageUrl"] && content && content.children && content.children.length > 0 &&
        <div style={{ position: "relative", flex: 1, marginRight: "20px", minWidth: 0 }}>
          {/* 왼쪽 화살표 */}
          {showLeftArrow && (
            <button
              style={{ ...leftArrowButtonStyle, paddingBottom: "5px",
                paddingRight: "0px" }}
              onClick={() => scrollMenu('left')}
              aria-label="왼쪽으로 이동"
              tabIndex={-1}
              // onMouseEnter={e => {
              //   e.target.style.background = 'rgba(0,0,0,0.45)'; // hover 시도 연하게(0.7 -> 0.45)
              //   e.target.style.transform = 'translateY(-50%) scale(1.1)';
              // }}
              // onMouseLeave={e => {
              //   e.target.style.background = 'rgba(0,0,0,0.3)';
              //   e.target.style.transform = 'translateY(-50%) scale(1)';
              // }}
            >
          {/iPhone|iPad|iPod/i.test(navigator.userAgent) ? (
            <span style={{color: 'transparent'}}>&#8249;<span style={{color: 'white'}}>&#8249;</span>&#8249;</span>            
          ) : (
            <>&#8249;</>
          )}

            </button>
          )}
          {/* 메뉴 바 */}
          <div 
            className="slide-top-menu-container"
            ref={menuRef}
            style={{
              overflowX: "auto",
              overflowY: "hidden",
              whiteSpace: "nowrap",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              touchAction: "pan-x",
              WebkitOverflowScrolling: "touch",
              margin: "0 45px", // 화살표 공간 확보
              minHeight: "100%",
              position: "relative"
            }}>
            <div style={{ display: "flex", padding: "20px 0 20px 0" }}>
              {content.children.map((c, index) => (
                <div
                  className="slide-top-menu-item"
                  key={index}
                  onClick={() => onMenuClick(index)}
                  style={index === selectedIndex ? selectedMenuItemStyle : menuItemStyle}
                >
                  {c.title}
                </div>
              ))}
            </div>
          </div>
          {/* 오른쪽 화살표 */}
          {showRightArrow && (
            <button
              style={{ 
                ...rightArrowButtonStyle, 
                paddingBottom: "5px",
                paddingLeft: "8px",
                top: "50%",
                right: "0",
                transform: "translate(35%, -50%)", // 수평+수직 중앙 정렬
                display: "flex",
                alignItems: "center", 
                justifyContent: "center",                
                position: "absolute",
                margin: "0 auto" // 수평 중앙 정렬을 위해 추가
              }}
              onClick={() => scrollMenu('right')}
              aria-label="오른쪽으로 이동"
              tabIndex={-1}
              // onMouseEnter={e => {
              //   e.target.style.background = 'rgba(0,0,0,0.45)';
              // }}
              // onMouseLeave={e => {
              //   e.target.style.background = 'rgba(0,0,0,0.3)';
              // }}
            >
            {/iPhone|iPad|iPod/i.test(navigator.userAgent) ? (
            <span style={{color: 'transparent'}}>&#8250;<span style={{color: 'white'}}>&#8250;</span>&#8250;</span>
          ) : (
            <>&#8250;</>
          )}
            </button>
          )}
        </div>
      }
    </div>
  );
};

export default TopMenuBar; 